/* @flow */
/**
 * Created by Ondra on 14.10.2016.
 */
import React from 'react';
import {connect} from 'react-redux';
import Keyboard from '../components/keyboard/Keyboard';
import {setField} from '../../common/lib/redux-fields/actions';
import {changeDeviceSettings} from '../../common/device/actions';
import {checkDomain} from '../../common/chooseDomain/actions';
import {removeErrors, setOfflineError} from '../../common/app/actions';
import {setFocusId} from '../../common/components/keyboard/actions';
import {isEnv} from '../../common/lib/util';
import {fullLoadingShow, fullLoadingHide} from '../../common/components/loadings/actions';
import QuitButton from '../components/buttons/QuitButton';
import LanguageSwitcher from '../components/intl/LanguageSwitcher';

class MigrationTroubleShooter extends React.Component {

    state: State = {
        migrationIdError: false
    };

    static propTypes = {
        msg: React.PropTypes.object,
        setOfflineError: React.PropTypes.func,
        setField: React.PropTypes.func,
        setFocusId: React.PropTypes.func,
        removeErrors: React.PropTypes.func,
        fields: React.PropTypes.object,
        error: React.PropTypes.object,
        organizationDomain: React.PropTypes.string,
        organizationName: React.PropTypes.string,
        deviceId: React.PropTypes.number,
        formDisabled: React.PropTypes.bool
    };

    constructor(props) {
        super(props);

        this.onChangeForm = this.onChangeForm.bind(this);
        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.onQuit = this.onQuit.bind(this);
    }

    onChangeForm({target: {name, value}}) {
        const {setField} = this.props;
        setField(name, value);
    }

    onFormSubmit(e) {
        let {organizationDomain} = this.props;
        e.preventDefault();
        const {fields} = this.props;
        this.setState({migrationIdError: false});

        const migrationId = fields.getIn('migrationId');
        if(!organizationDomain) organizationDomain = localStorage.getItem('domain');
        location.href = `/?domain=${organizationDomain}&migrationId=${migrationId}`;
    }

    onQuit(e) {
        if (isEnv(['android_app', 'electron'])) {
            if (typeof window.parent.Ocellot !== 'undefined') {
                window.parent.Ocellot.quit();
            } else {
                window.parent.ocellotQuit();
            }
        }
    }

    componentWillMount() {
        const {setField, removeErrors, fullLoadingShow} = this.props;
        fullLoadingShow();
        removeErrors();
        setField('migrationId', '');
    }

    componentDidMount() {
        const {fullLoadingHide} = this.props;
        fullLoadingHide();
    }

    componentWillUnmount() {
        const {removeErrors} = this.props;
        removeErrors();
    }

    render() {
        const {fields, formDisabled, error, setFocusId, msg, organizationName} = this.props;
        const {migrationIdError} = this.state;

        return (
            <div id="migrationTroubleshoot-page" className="pageLogin keyboardPanel">
                <h1 className="pageLogin-logo view-big">
                    {msg.global.appName} {!!organizationName && `- ${organizationName}`}
                </h1>
                {isEnv(['android_app', 'electron']) &&
                    <div className="pageLogin-quit">
                        <button className="boxBtn color-red" onClick={this.onQuit}>
                            <QuitButton/>
                        </button>
                    </div>
                }
                <LanguageSwitcher/>
                <div className="keyboardPanel-panel">
                    <div className="form">
                        <form className="formWithKeyboard"
                              autoComplete="off"
                              id="formWithKeyboard"
                              onChange={e => this.onChangeForm(e)}
                              onSubmit={e => this.onFormSubmit(e)}>
                            <fieldset disabled={formDisabled}>
                                <div className="form-row">
                                    <label htmlFor="migrationId" className="form-label">{msg.migrationTroubleShooter.migrationId}</label>
                                    <input autoFocus
                                           autoComplete="off"
                                           onFocus={() => setFocusId('migrationId')}
                                           type="text"
                                           className="form-input"
                                           name="migrationId"
                                           tabIndex="1"
                                           value={fields.getIn('migrationId')}
                                           id="migrationId"/>
                                </div>
                                {!!error &&
                                    <div className="form-errors">
                                        <div className="errors">
                                            <ul>
                                                {error.map((err, i) =>
                                                    <li key={`error-key-${i}`}>{err}</li>
                                                )}
                                            </ul>
                                        </div>
                                    </div>
                                }

                                {migrationIdError &&
                                    <div className="form-errors">
                                        <div className="errors">
                                            <ul>
                                                <li>{msg.migrationTroubleShooter.migrationIdError}</li>
                                            </ul>
                                        </div>
                                    </div>
                                }
                                <div className="form-btns">
                                    <button type="submit" className="btn btn-green btn-block">{msg.domain.continue}</button>
                                    <br/>
                                    <a href="/" className="btn btn-red btn-block">{msg.global.back}</a>
                                </div>
                            </fieldset>
                        </form>
                    </div>
                </div>
                <div className="keyboardPanel-keyboard">
                    {isEnv(['electron', 'web_desktop']) &&
                        <Keyboard />
                    }
                </div>
            </div>
        );
    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    fields: state.fields,
    formDisabled: state.login.get('formDisabled'),
    organizationDomain: state.device.get('organizationDomain'),
    organizationName: state.device.get('organizationName'),
    error: state.app.get('error')
}), {
    setField, checkDomain, removeErrors, setFocusId, setOfflineError, changeDeviceSettings, fullLoadingShow,
    fullLoadingHide
})(MigrationTroubleShooter);



// WEBPACK FOOTER //
// ./src/browser/login/MigrationTroubleShooter.js